var map = {
	"./angle-left.svg": "1e61",
	"./angle-right.svg": "6884",
	"./arrow-down.svg": "c874",
	"./caret-down.svg": "3f24",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./discord.svg": "e3a3",
	"./earth.svg": "6615",
	"./exclamation-triangle.svg": "6339",
	"./facebook.svg": "8485",
	"./group.svg": "51a3",
	"./info-circle.svg": "6668",
	"./microphone-refresh.svg": "e33b",
	"./microphone.svg": "4eb8",
	"./pause.svg": "644b",
	"./play.svg": "dab1",
	"./refresh.svg": "53fa",
	"./send.svg": "5b6e",
	"./steam-logo.svg": "65de",
	"./triangle.svg": "a8fe",
	"./twitch.svg": "cfaa",
	"./twitter.svg": "acf9",
	"./user-light.svg": "233e",
	"./user-regular.svg": "2bdc",
	"./user-solid.svg": "bd92",
	"./vk.svg": "13e3",
	"./vortex.svg": "193e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";